Vue.component('manage-emails', {
    props: ['user-id', 'client-id'],

    data() {
        return {
            loading: false,

            modalLoading: false,

            testing: false,

            deleting: false,

            editing: false,

            defaulting: false,

            emails: [],

            clients: [],

            domains: [],

            activeId: 0,

            testResult: null,

            createEmailForm: $.extend(true, new Form({
                data: {
                    client: '',
                    username: '',
                    domain: '',
                    type: '',
                    password: '',
                    host: '',
                    port: '',
                    encryption: '',
                    operations: 0
                }
            }), {}),

            editEmailForm: $.extend(true, new Form({
                data: {
                    client: '',
                    username: '',
                    email: '',
                    domain: '',
                    type: '',
                    password: '',
                    host: '',
                    port: '',
                    encryption: '',
                    operations: 0
                }
            }), {}),

            updateSignatureForm: $.extend(true, new Form({
                data: {
                    signature: ''
                }
            }), {}),

            interval: null,

            filters: {
                client: '',
                search: ''
            }
        };
    },

    mounted () {
        if (this.clientId != undefined) {
            this.filters.client = this.clientId;

            this.loadDomains();
        }

        // Load the list of emails on account
        this.getEmails();

        $('#email-edit, #email-create').on('hidden.bs.modal', () => {
            this.editEmailForm.resetForm();
            this.createEmailForm.resetForm();
        });
    },

    methods: {
        loadDomains () {
            this.loading = true;

            axios.get('/api/domains', {
                params: {
                    client_id: this.clientId
                }
            }).then((response) => {
                this.loading = false;
                this.domains = response.data;
            });
        },

        setDomains () {
            for (let client in this.clients) {
                if (
                    this.clients[client].id == this.createEmailForm.data.client ||
                    this.clients[client].id == this.editEmailForm.data.client
                ) {
                    this.domains = this.clients[client].domains;
                }
            }
        },

        getEmails () {
            this.loading = true;

            axios.get('/api/emails', {
                params: {
                    user_id: this.userId,
                    ...this.filters
                }
            }).then((response) => {
                this.emails = response.data.emails;
                this.clients = response.data.clients;

                this.loading = false;
            });
        },

        test(id) {
            this.testing = true;

            $('#email-test-results').modal('show');

            const CancelToken = axios.CancelToken;
            const source = CancelToken.source();

            axios.post('/api/emails/test', {}, {
                params: {
                    id
                },

                cancelToken: source.token
            }).then((response) => {
                this.testing = false;

                window.clearTimeout(this.interval);

                this.testResult = response.data;
            }).catch(() => {
                window.clearTimeout(this.interval);
            });

            // Allow up to 15 seconds. If 15 seconds passes cancel the request
            this.interval = setTimeout(() => {
                source.cancel('Request Timeout');

                this.testing = false;
                this.testResult = {
                    status: false,
                    message: 'Mail server took too long to respond, please check your settings'
                };
            }, 15000);
        },

        create () {
            const CancelToken = axios.CancelToken;
            const source = CancelToken.source();

            if (this.clientId != undefined) {
                this.createEmailForm.data.client = this.clientId;
            }
            
            Http.post('/api/emails/create', this.createEmailForm, {
                params: {
                    user_id: this.userId
                },

                cancelToken: source.token
            }).then((response) => {
                // Reset, no need to display
                this.createEmailForm.resetForm();
                this.createEmailForm.resetAlert();

                // Reload the main list
                this.getEmails();

                // Cancel the cancel...
                window.clearTimeout(this.interval);

                // Open the DNS information
                $('#email-create').modal('hide');
            }).catch(() => {
                window.clearTimeout(this.interval);
            });

            // Allow up to 15 seconds. If 15 seconds passes cancel the request
            this.interval = setTimeout(() => {
                source.cancel('Request Timeout');

                this.createEmailForm.finishProcessing();
                this.createEmailForm.setAlert('error', 'Mail server took too long to respond, please check your settings');
            }, 15000);
        },

        remove (id) {
            this.activeId = id;

            $('#email-delete').modal('show');
        },

        doRemove () {
            this.deleting = true;

            axios.post('/api/emails/delete', {}, {
                params: {
                    id: this.activeId
                }
            }).then(() => {
                $('#email-delete').modal('hide');

                this.getEmails();

                this.deleting = false;
            });
        },

        handlePasswordChange (value) {
            this.createEmailForm.data.password = value;
            this.editEmailForm.data.password = value;
        },

        makeDefault (id) {
            this.defaulting = true;

            axios.post('/api/emails/default', {}, {
                params: {
                    id,
                    user_id: this.userId
                }
            }).then(() => {
                this.getEmails();

                this.defaulting = false;
            });
        },

        editEmail (email) {
            this.activeId = email.id;

            this.editEmailForm.data.client = email.client_id;
            this.editEmailForm.data.host = email.incoming_host;
            this.editEmailForm.data.port = email.incoming_port;
            this.editEmailForm.data.encryption = email.incoming_encryption;
            this.editEmailForm.data.type = email.type;
            this.editEmailForm.data.operations = parseInt(email.operations);

            // Split the email
            let emailParts = email.email.split('@');
            this.editEmailForm.data.username = emailParts[0];
            this.editEmailForm.data.domain = emailParts[1];

            this.setDomains();

            $('#email-edit').modal('show');
        },

        updateEmail () {
            this.editing = true;

            Http.post('/api/emails/update', this.editEmailForm, {
                params: {
                    id: this.activeId
                }
            }).then(() => {
                $('#email-edit').modal('hide');

                this.getEmails();

                this.editing = false;
            });
        },

        signature (id) {
            this.activeId = id;
            this.modalLoading = true;

            $('#email-signature').modal('show');

            axios.get('/api/emails/signature', {
                params: {
                    id
                }
            }).then((response) => {
                this.modalLoading = false;

                this.updateSignatureForm.data.signature = response.data;
            });
        },


        updateSignature () {
            Http.post('/api/emails/update_signature', this.updateSignatureForm, {
                params: {
                    id: this.activeId
                }
            });
        },

        office365Settings () {
            this.createEmailForm.data.host = 'outlook.office365.com';
            this.createEmailForm.data.port = 993;
            this.createEmailForm.data.encryption = 'ssl';

            this.editEmailForm.data.host = 'outlook.office365.com';
            this.editEmailForm.data.port = 993;
            this.editEmailForm.data.encryption = 'ssl';
        },

        gsuite () {
            this.createEmailForm.data.host = 'imap.gmail.com';
            this.createEmailForm.data.port = 993;
            this.createEmailForm.data.encryption = 'ssl';

            this.editEmailForm.data.host = 'imap.gmail.com';
            this.editEmailForm.data.port = 993;
            this.editEmailForm.data.encryption = 'ssl';
        }
    },

    watch: {
        userId () {
            this.getEmails();
        }
    }
});